import axios from "axios";
import { common } from "../../utils";
import { API_URL } from "../../utils/api-utils";

export const GetListHistory = async (param) => {
  let url = `${API_URL.Query}/api/Query/GetListExportHeader`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};


export const DownloadFile = async (param) => {
  let url = `${API_URL.Query}/api/Query/DownloadFile`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};
